<div class="config-form-container">
	<div *ngIf="loading" class="text-center p-4">
		<mat-spinner diameter="50"></mat-spinner>
		<p>Loading configuration...</p>
	</div>

	<form [formGroup]="configForm" *ngIf="!loading">
		<mat-tab-group animationDuration="150ms">

			<!-- ── Tab 1: Connection ─────────────────────────────────────── -->
			<mat-tab label="Connection">
				<div class="tab-content-pad">
					<div class="row mb-3 mt-3">
						<div class="col-md-6">
							<mat-slide-toggle formControlName="enabled">Enable 3PL Integration</mat-slide-toggle>
						</div>
						<div class="col-md-6">
							<mat-slide-toggle formControlName="test_mode">Test Mode</mat-slide-toggle>
						</div>
					</div>

					<div class="row mb-3">
						<div class="col-md-6">
							<mat-form-field appearance="fill" class="w-100">
								<mat-label>Integration Type</mat-label>
								<mat-select formControlName="integration_type">
									<mat-option value="API">API</mat-option>
									<mat-option value="PGS">PGS</mat-option>
									<mat-option value="EDI">EDI</mat-option>
									<mat-option value="SFTP">SFTP</mat-option>
									<mat-option value="FTP">FTP</mat-option>
								</mat-select>
							</mat-form-field>
						</div>
						<div class="col-md-6">
							<mat-form-field appearance="fill" class="w-100">
								<mat-label>3PL Warehouse Code</mat-label>
								<input matInput formControlName="warehouse_code" required placeholder="e.g. CM, PICO, FW, NJ, 00">
								<mat-hint>3PL facility identifier (not an ERP location)</mat-hint>
							</mat-form-field>
						</div>
					</div>

					<!-- API Configuration -->
					<div *ngIf="integrationType === 'API'" formGroupName="config_json">
						<div formGroupName="api" class="config-section">
							<h5>API Configuration</h5>
							<div class="row">
								<div class="col-md-12">
									<mat-form-field appearance="fill" class="w-100">
										<mat-label>Base URL</mat-label>
										<input matInput formControlName="baseUrl" placeholder="https://api.3plprovider.com">
									</mat-form-field>
								</div>
							</div>
							<div class="row">
								<div class="col-md-6">
									<mat-form-field appearance="fill" class="w-100">
										<mat-label>API Key</mat-label>
										<input matInput type="password" formControlName="apiKey">
									</mat-form-field>
								</div>
								<div class="col-md-6">
									<mat-form-field appearance="fill" class="w-100">
										<mat-label>API Secret</mat-label>
										<input matInput type="password" formControlName="apiSecret">
									</mat-form-field>
								</div>
							</div>
							<div class="row">
								<div class="col-md-6">
									<mat-form-field appearance="fill" class="w-100">
										<mat-label>Timeout (seconds)</mat-label>
										<input matInput type="number" formControlName="timeout">
									</mat-form-field>
								</div>
								<div class="col-md-6">
									<mat-form-field appearance="fill" class="w-100">
										<mat-label>Retry Attempts</mat-label>
										<input matInput type="number" formControlName="retryAttempts">
									</mat-form-field>
								</div>
							</div>
						</div>
					</div>

					<!-- PGS Configuration -->
					<div *ngIf="integrationType === 'PGS'" formGroupName="config_json">
						<div formGroupName="pgs" class="config-section">
							<h5>PGS Configuration</h5>
							<div class="row">
								<div class="col-md-12">
									<mat-form-field appearance="fill" class="w-100">
										<mat-label>Base URL</mat-label>
										<input matInput formControlName="baseUrl" placeholder="https://api.pgs360.com/CustomerIntegrator">
									</mat-form-field>
								</div>
							</div>
							<div class="row">
								<div class="col-md-12">
									<mat-form-field appearance="fill" class="w-100">
										<mat-label>Token URL (optional)</mat-label>
										<input matInput formControlName="tokenUrl" placeholder="https://api.pgs360.com/fulfillment_client/security/token">
										<mat-hint>Leave blank to use Base URL + /api/Security/Token</mat-hint>
									</mat-form-field>
								</div>
							</div>
							<div class="row">
								<div class="col-md-6">
									<mat-form-field appearance="fill" class="w-100">
										<mat-label>User ID</mat-label>
										<input matInput formControlName="userId">
									</mat-form-field>
								</div>
								<div class="col-md-6">
									<mat-form-field appearance="fill" class="w-100">
										<mat-label>Password</mat-label>
										<input matInput type="password" formControlName="passwd">
									</mat-form-field>
								</div>
							</div>
							<div class="row">
								<div class="col-md-4">
									<mat-form-field appearance="fill" class="w-100">
										<mat-label>Default Warehouse</mat-label>
										<mat-select formControlName="defaultWarehouse">
											<mat-option value="CM">CM</mat-option>
											<mat-option value="PICO">PICO</mat-option>
											<mat-option value="FW">FW</mat-option>
											<mat-option value="NJ">NJ</mat-option>
										</mat-select>
									</mat-form-field>
								</div>
								<div class="col-md-4">
									<mat-form-field appearance="fill" class="w-100">
										<mat-label>Default Outbound Channel</mat-label>
										<mat-select formControlName="defaultOutboundChannel">
											<mat-option value="B2B">B2B</mat-option>
											<mat-option value="B2C">B2C</mat-option>
										</mat-select>
									</mat-form-field>
								</div>
								<div class="col-md-4">
									<mat-form-field appearance="fill" class="w-100">
										<mat-label>B2C Service Type</mat-label>
										<input matInput formControlName="b2cServiceType" placeholder="Ground">
									</mat-form-field>
								</div>
							</div>
							<div class="row">
								<div class="col-md-4">
									<mat-form-field appearance="fill" class="w-100">
										<mat-label>Inventory page size (maxResults)</mat-label>
										<input matInput type="number" formControlName="inventoryMaxResults" min="1" max="2000">
										<mat-hint>Default 500; paginates until catalog complete</mat-hint>
									</mat-form-field>
								</div>
								<div class="col-md-4">
									<mat-form-field appearance="fill" class="w-100">
										<mat-label>ERP location for 3PL inventory</mat-label>
										<input matInput formControlName="inventoryLoccode" placeholder="e.g. 01">
										<mat-hint>Default ERP warehouse when PGS sends an unknown code</mat-hint>
									</mat-form-field>
								</div>
							</div>
							<div class="row">
								<div class="col-md-12">
									<mat-form-field appearance="fill" class="w-100">
										<mat-label>PGS warehouse → ERP location map (JSON)</mat-label>
										<textarea matInput formControlName="warehouseMapJson" rows="4" placeholder='{ "01": "CM" }'></textarea>
										<mat-hint>Maps PGS inventory warehouse values to ERP loccode. Leave empty if every PGS code already matches an ERP location.</mat-hint>
									</mat-form-field>
								</div>
							</div>
							<div formGroupName="lob" class="row mt-2">
								<div class="col-md-12 mb-2">
									<h6 class="mb-0">SKU line of business</h6>
								</div>
								<div class="col-md-4">
									<mat-form-field appearance="fill" class="w-100">
										<mat-label>Default</mat-label>
										<input matInput formControlName="default" placeholder="Kevin Murphy">
										<mat-hint>If nothing else matches</mat-hint>
									</mat-form-field>
								</div>
								<div class="col-md-8">
									<mat-form-field appearance="fill" class="w-100">
										<mat-label>Manufacturer ID → LOB (JSON)</mat-label>
										<textarea matInput formControlName="byManufacturerIdJson" rows="4" placeholder='{ "26": "Kevin Murphy", "221": "Eleven" }'></textarea>
										<mat-hint>Keys: manufacturer_id from your manufacturer table</mat-hint>
									</mat-form-field>
								</div>
							</div>
						</div>
					</div>

					<!-- EDI Configuration -->
					<div *ngIf="integrationType === 'EDI'" formGroupName="config_json">
						<div formGroupName="edi" class="config-section">
							<h5>EDI Configuration</h5>
							<div class="row">
								<div class="col-md-6">
									<mat-form-field appearance="fill" class="w-100">
										<mat-label>Trading Partner ID</mat-label>
										<input matInput formControlName="tradingPartnerId">
									</mat-form-field>
								</div>
								<div class="col-md-3">
									<mat-form-field appearance="fill" class="w-100">
										<mat-label>ISA Qualifier</mat-label>
										<input matInput formControlName="isaQualifier">
									</mat-form-field>
								</div>
								<div class="col-md-3">
									<mat-form-field appearance="fill" class="w-100">
										<mat-label>GS Qualifier</mat-label>
										<input matInput formControlName="gsQualifier">
									</mat-form-field>
								</div>
							</div>
						</div>
					</div>

					<!-- SFTP/FTP Configuration -->
					<div *ngIf="integrationType === 'SFTP' || integrationType === 'FTP'" formGroupName="config_json">
						<div formGroupName="sftp" class="config-section">
							<h5>{{ integrationType }} Configuration</h5>
							<div class="row">
								<div class="col-md-6">
									<mat-form-field appearance="fill" class="w-100">
										<mat-label>Host</mat-label>
										<input matInput formControlName="host" placeholder="sftp.3plprovider.com">
									</mat-form-field>
								</div>
								<div class="col-md-6">
									<mat-form-field appearance="fill" class="w-100">
										<mat-label>Port</mat-label>
										<input matInput type="number" formControlName="port">
									</mat-form-field>
								</div>
							</div>
							<div class="row">
								<div class="col-md-6">
									<mat-form-field appearance="fill" class="w-100">
										<mat-label>Username</mat-label>
										<input matInput formControlName="username">
									</mat-form-field>
								</div>
								<div class="col-md-6">
									<mat-form-field appearance="fill" class="w-100">
										<mat-label>Password</mat-label>
										<input matInput type="password" formControlName="password">
									</mat-form-field>
								</div>
							</div>
							<div class="row">
								<div class="col-md-6">
									<mat-form-field appearance="fill" class="w-100">
										<mat-label>Remote Path (Inbound)</mat-label>
										<input matInput formControlName="remotePath">
									</mat-form-field>
								</div>
								<div class="col-md-6">
									<mat-form-field appearance="fill" class="w-100">
										<mat-label>Outbound Path</mat-label>
										<input matInput formControlName="outboundPath">
									</mat-form-field>
								</div>
							</div>
						</div>
					</div>
				</div>
			</mat-tab>

			<!-- ── Tab 2: Order Export ───────────────────────────────────── -->
			<mat-tab label="Order Export">
				<div class="tab-content-pad" formGroupName="config_json">
					<div class="row mt-3">
						<div class="col-md-4">
							<mat-form-field appearance="fill" class="w-100">
								<mat-label>Allowed statuses (export)</mat-label>
								<mat-select formControlName="allowed_statuses" multiple placeholder="Default — any allowed by server">
									<mat-option *ngFor="let s of orderStatusesForSelect" [value]="+s.order_status_id">{{ s.name }} ({{ s.order_status_id }})</mat-option>
								</mat-select>
								<mat-hint>Only these statuses may be exported (when set)</mat-hint>
							</mat-form-field>
						</div>
						<div class="col-md-4">
							<mat-form-field appearance="fill" class="w-100">
								<mat-label>Blocked statuses</mat-label>
								<mat-select formControlName="blocked_statuses" multiple placeholder="None blocked">
									<mat-option *ngFor="let s of orderStatusesForSelect" [value]="+s.order_status_id">{{ s.name }} ({{ s.order_status_id }})</mat-option>
								</mat-select>
								<mat-hint>Never export orders in these statuses</mat-hint>
							</mat-form-field>
						</div>
						<div class="col-md-4">
							<mat-form-field appearance="fill" class="w-100">
								<mat-label>Shipped statuses</mat-label>
								<mat-select formControlName="shipped_statuses" multiple placeholder="Default — server shipped list">
									<mat-option *ngFor="let s of orderStatusesForSelect" [value]="+s.order_status_id">{{ s.name }} ({{ s.order_status_id }})</mat-option>
								</mat-select>
								<mat-hint>Treated as already shipped / skip re-export</mat-hint>
							</mat-form-field>
						</div>
					</div>

					<h6 class="mt-4 mb-2">Stock checks before export</h6>
					<div class="row">
						<div class="col-md-6">
							<mat-slide-toggle formControlName="split_partial_backorder_enabled">Allow splitting partial orders (manual / API)</mat-slide-toggle>
							<mat-slide-toggle formControlName="split_uninvoiced_open_lines_enabled" class="d-block mt-2">Allow splitting uninvoiced lines to new SO</mat-slide-toggle>
							<mat-slide-toggle formControlName="auto_split_partial_before_export" class="d-block mt-2">Auto-split partial orders before sending to 3PL</mat-slide-toggle>
							<mat-form-field appearance="fill" class="w-100 mt-2" style="max-width: 380px">
								<mat-label>Status for new back-order SO</mat-label>
								<mat-select formControlName="backorder_orderstatusid">
									<mat-option [value]="">— Look up by name "BackOrder"</mat-option>
									<mat-option *ngFor="let s of orderStatusesForSelect" [value]="+s.order_status_id">{{ s.name }} ({{ s.order_status_id }})</mat-option>
								</mat-select>
							</mat-form-field>
							<mat-slide-toggle formControlName="queue_backorder_for_tpl3pl" class="d-block mt-1">Also queue new back-order SO for 3PL</mat-slide-toggle>
						</div>
						<div class="col-md-6">
							<mat-slide-toggle formControlName="skip_not_fillable_orders">Hold not-fillable and partial-fillability orders</mat-slide-toggle>
							<mat-form-field appearance="fill" class="w-100 mt-2" style="max-width: 240px">
								<mat-label>Re-check after (minutes)</mat-label>
								<input matInput type="number" min="1" formControlName="not_fillable_hold_minutes">
								<mat-hint>Default 60</mat-hint>
							</mat-form-field>
						</div>
					</div>

					<h6 class="mt-4 mb-2">Payment checks on split back-orders</h6>
					<div class="row">
						<div class="col-md-6">
							<mat-form-field appearance="fill" class="w-100">
								<mat-label>"Hold For Payment" status</mat-label>
								<mat-select formControlName="hold_for_payment_orderstatusid" [compareWith]="compareByStatusId">
									<mat-option [value]="">— Use global HoldForPaymentOrderStatusId / name lookup</mat-option>
									<mat-option *ngFor="let s of orderStatusesForSelect" [value]="+s.order_status_id">{{ s.name }} ({{ s.order_status_id }})</mat-option>
								</mat-select>
								<mat-hint>Assigned when bumping a split back-order off the queue</mat-hint>
							</mat-form-field>
						</div>
						<div class="col-md-6">
							<mat-form-field appearance="fill" class="w-100">
								<mat-label>Force must-pay terms (Hold For Payment)</mat-label>
								<mat-select formControlName="must_pay_payterms" multiple [compareWith]="comparePayterms">
									<mat-option *ngFor="let t of paymentTermsForSelect" [value]="t.termsindicator">
										{{ t.terms }} <span class="text-muted">({{ t.termsindicator }})</span>
									</mat-option>
								</mat-select>
								<mat-hint>Overrides auto-detect (paymentterms.cc_process)</mat-hint>
							</mat-form-field>
						</div>
						<div class="col-md-6 mt-2">
							<mat-form-field appearance="fill" class="w-100">
								<mat-label>Force net/on-account terms (no payment required)</mat-label>
								<mat-select formControlName="net_payterms" multiple [compareWith]="comparePayterms">
									<mat-option *ngFor="let t of paymentTermsForSelect" [value]="t.termsindicator">
										{{ t.terms }} <span class="text-muted">({{ t.termsindicator }})</span>
									</mat-option>
								</mat-select>
								<mat-hint>Overrides auto-detect for terms that don't match "NET N" pattern</mat-hint>
							</mat-form-field>
						</div>
					</div>
				</div>
			</mat-tab>

			<!-- ── Tab 3: Shipment & Invoicing ──────────────────────────── -->
			<mat-tab label="Shipment & Invoicing">
				<div class="tab-content-pad" formGroupName="config_json">
					<div class="row mb-2 mt-3">
						<div class="col-md-6">
							<mat-slide-toggle formControlName="auto_invoice_on_shipment">Auto-invoice on shipment</mat-slide-toggle>
						</div>
						<div class="col-md-6">
							<mat-slide-toggle formControlName="email_customer_on_3pl_invoice">Email customer on invoice</mat-slide-toggle>
						</div>
					</div>
					<div class="row mb-2" formGroupName="pgs">
						<div class="col-md-12">
							<mat-slide-toggle formControlName="auto_credit_on_receipt">Auto-credit customer returns on receipt</mat-slide-toggle>
							<small class="form-text text-muted">When the 3PL confirms a return received, post the customer's credit note automatically. Off = every RMA waits for a manual Finalize.</small>
						</div>
					</div>

					<h6 class="text-muted mt-3 mb-2">Payment usage (worker auto-apply)</h6>
					<div formGroupName="payment_usage">
						<div class="row mb-2">
							<div class="col-md-12">
								<mat-slide-toggle formControlName="apply_customer_ar_on_invoice">Auto-apply AR on invoice</mat-slide-toggle>
							</div>
						</div>
						<div class="row mb-2">
							<div class="col-md-4">
								<mat-form-field appearance="fill" class="w-100">
									<mat-label>Auto-apply types</mat-label>
									<input matInput formControlName="ar_auto_apply_types_text" placeholder="11 or 11,12" autocomplete="off">
									<mat-hint>11 = credit memo; 12 = open receipt</mat-hint>
								</mat-form-field>
							</div>
							<div class="col-md-4">
								<mat-form-field appearance="fill" class="w-100">
									<mat-label>Credit branch scope</mat-label>
									<mat-select formControlName="credit_branch_scope">
										<mat-option value="branch">Same branch as order</mat-option>
										<mat-option value="debtor">Debtor-wide (any branch)</mat-option>
									</mat-select>
								</mat-form-field>
							</div>
							<div class="col-md-4">
								<mat-form-field appearance="fill" class="w-100">
									<mat-label>Max auto-apply per invoice</mat-label>
									<input matInput type="number" formControlName="credit_max_auto_apply_amount" placeholder="Unlimited" min="0" step="0.01">
								</mat-form-field>
							</div>
						</div>
						<div class="row mb-2">
							<div class="col-md-12">
								<mat-slide-toggle formControlName="allow_manual_open_payment_application">Allow operators to manually apply open payments (type 12)</mat-slide-toggle>
							</div>
						</div>
					</div>

					<h6 class="text-muted mt-4 mb-2">Order status — after export</h6>
					<div class="row mb-3">
						<div class="col-md-6 col-lg-4">
							<mat-form-field appearance="fill" class="w-100">
								<mat-label>Status when exported</mat-label>
								<mat-select formControlName="status_on_export_success">
									<mat-option [value]="">— Not set (server default: 5 Picking)</mat-option>
									<mat-option *ngFor="let s of orderStatusesForSelect" [value]="+s.order_status_id">{{ s.name }} ({{ s.order_status_id }})</mat-option>
								</mat-select>
								<mat-hint>Only updates if current status is below the chosen status (or 52/53)</mat-hint>
							</mat-form-field>
						</div>
					</div>

					<h6 class="text-muted mt-2 mb-2">Order status — shipment &amp; tracking</h6>
					<div class="row">
						<div class="col-md-6 col-lg-4">
							<mat-form-field appearance="fill" class="w-100">
								<mat-label>Status when shipment received</mat-label>
								<mat-select formControlName="status_on_shipment_received">
									<mat-option [value]="">— Use shipped statuses</mat-option>
									<mat-option *ngFor="let s of orderStatusesForSelect" [value]="+s.order_status_id">{{ s.name }} ({{ s.order_status_id }})</mat-option>
								</mat-select>
							</mat-form-field>
						</div>
						<div class="col-md-6 col-lg-4">
							<mat-form-field appearance="fill" class="w-100">
								<mat-label>Status when in transit</mat-label>
								<mat-select formControlName="status_on_tracking_in_transit">
									<mat-option [value]="">— Skip</mat-option>
									<mat-option *ngFor="let s of orderStatusesForSelect" [value]="+s.order_status_id">{{ s.name }} ({{ s.order_status_id }})</mat-option>
								</mat-select>
							</mat-form-field>
						</div>
						<div class="col-md-6 col-lg-4">
							<mat-form-field appearance="fill" class="w-100">
								<mat-label>Status when delivered</mat-label>
								<mat-select formControlName="status_on_tracking_delivered">
									<mat-option [value]="">— Skip</mat-option>
									<mat-option *ngFor="let s of orderStatusesForSelect" [value]="+s.order_status_id">{{ s.name }} ({{ s.order_status_id }})</mat-option>
								</mat-select>
							</mat-form-field>
						</div>
						<div class="col-md-6 col-lg-4">
							<mat-form-field appearance="fill" class="w-100">
								<mat-label>Status when invoice failed</mat-label>
								<mat-select formControlName="status_on_invoice_failed">
									<mat-option [value]="">— Skip</mat-option>
									<mat-option *ngFor="let s of orderStatusesForSelect" [value]="+s.order_status_id">{{ s.name }} ({{ s.order_status_id }})</mat-option>
								</mat-select>
								<mat-hint>e.g. 91 Needs Invoiced</mat-hint>
							</mat-form-field>
						</div>
						<div class="col-md-6 col-lg-4">
							<mat-form-field appearance="fill" class="w-100">
								<mat-label>Status when shipment approved</mat-label>
								<mat-select formControlName="status_on_shipment_approved">
									<mat-option [value]="">— No change</mat-option>
									<mat-option *ngFor="let s of orderStatusesForSelect" [value]="+s.order_status_id">{{ s.name }} ({{ s.order_status_id }})</mat-option>
								</mat-select>
							</mat-form-field>
						</div>
					</div>
				</div>
			</mat-tab>

			<!-- ── Tab 4: Invoice Worker ─────────────────────────────────── -->
			<mat-tab label="Invoice Worker">
				<div class="tab-content-pad" formGroupName="config_json">
					<div class="row mb-2 mt-3">
						<div class="col-md-12">
							<mat-slide-toggle formControlName="shipment_invoice_worker_enabled">Enable invoice worker</mat-slide-toggle>
							<mat-hint class="d-block">Allows tpl3pl_shipment_invoice_worker.php to run on schedule (without --force)</mat-hint>
						</div>
					</div>
					<div class="row mb-2 mt-3">
						<div class="col-md-12">
							<mat-slide-toggle formControlName="worker_stage2_enabled">Stage 2 — reauth &amp; retry</mat-slide-toggle>
							<mat-hint class="d-block">When stage 1 fails due to a canceled/expired card hold, automatically reauthorize and retry invoicing</mat-hint>
						</div>
					</div>
					<div class="row mb-2 mt-3">
						<div class="col-md-12">
							<mat-slide-toggle formControlName="worker_stage3_enabled">Stage 3 — on-account fallback</mat-slide-toggle>
							<mat-hint class="d-block">After stage 2 fails, invoice on account (skipping card capture) once the shipment is old enough</mat-hint>
						</div>
					</div>
					<div class="row mb-2 mt-3">
						<div class="col-md-12">
							<mat-slide-toggle formControlName="worker_auto_attach_card">Auto-attach saved card to order</mat-slide-toggle>
							<mat-hint class="d-block">Before invoicing, attach the customer's default saved card to the order if none is present</mat-hint>
						</div>
					</div>
					<div class="row mt-3">
						<div class="col-md-4">
							<mat-form-field appearance="fill" class="w-100">
								<mat-label>Max shipments per run</mat-label>
								<input matInput type="number" formControlName="worker_max_per_run" min="1">
								<mat-hint>Default 100</mat-hint>
							</mat-form-field>
						</div>
						<div class="col-md-4">
							<mat-form-field appearance="fill" class="w-100">
								<mat-label>Stage 2 delay (ms)</mat-label>
								<input matInput type="number" formControlName="worker_stage2_sleep_ms" min="0">
								<mat-hint>Pause between reauth and retry. Default 500</mat-hint>
							</mat-form-field>
						</div>
						<div class="col-md-4">
							<mat-form-field appearance="fill" class="w-100">
								<mat-label>Stage 3 min ship age (days)</mat-label>
								<input matInput type="number" formControlName="worker_stage3_min_ship_age_days" min="0">
								<mat-hint>On-account fallback only after this many days. Default 0</mat-hint>
							</mat-form-field>
						</div>
					</div>
				</div>
			</mat-tab>

			<!-- ── Tab 5: Products & Sync (PGS only) ────────────────────── -->
			<mat-tab label="Products & Sync" *ngIf="integrationType === 'PGS'">
				<div class="tab-content-pad" formGroupName="config_json">
					<h5 class="mt-3">Products to push to 3PL</h5>
					<p class="text-muted small mb-2">Leave all empty to push all non-discontinued items.</p>
					<div class="row">
						<div class="col-md-4">
							<mat-form-field appearance="fill" class="w-100">
								<mat-label>Categories to push</mat-label>
								<mat-select formControlName="sku_categories" multiple placeholder="All categories">
									<mat-option *ngFor="let c of categories" [value]="c.categoryid">{{ c.categorydescription }}{{ c.categoryid ? ' (' + c.categoryid + ')' : '' }}</mat-option>
								</mat-select>
							</mat-form-field>
						</div>
						<div class="col-md-4">
							<mat-form-field appearance="fill" class="w-100">
								<mat-label>Product lines to push</mat-label>
								<mat-select formControlName="sku_lines" multiple placeholder="All product lines">
									<mat-option *ngFor="let p of productlines" [value]="p.line_field">{{ p.line_description }}{{ p.line_field ? ' (' + p.line_field + ')' : '' }}</mat-option>
								</mat-select>
							</mat-form-field>
						</div>
						<div class="col-md-4">
							<mat-form-field appearance="fill" class="w-100">
								<mat-label>Brands to push</mat-label>
								<mat-select formControlName="sku_manufacturers" multiple placeholder="All brands" [compareWith]="compareByManufacturerId">
									<mat-option *ngFor="let b of brands" [value]="b.manufacturer_id">{{ b.name }}{{ b.mfg_code ? ' (' + b.mfg_code + ')' : '' }}</mat-option>
								</mat-select>
							</mat-form-field>
						</div>
					</div>

					<h5 class="mt-4">Inventory sync ledger</h5>
					<mat-slide-toggle formControlName="skip_gl_for_3pl_inventory">Skip GL posting for 3PL inventory pulls</mat-slide-toggle>
					<mat-hint class="d-block mt-1">Stock movements are still written. When off (default), GL follows manual inventory adjustment rules.</mat-hint>

					<h5 class="mt-4">PGS Status Sync → ERP Order Status</h5>
					<p class="text-muted small mb-3">Maps PGS status text from the tpl3pl_pgs_status_worker.php poll to ERP order statuses. Matching is case-insensitive substring.</p>

					<div class="d-flex justify-content-between align-items-center mb-2">
						<h6 class="mb-0">PGS Status Mappings</h6>
						<button mat-raised-button color="accent" (click)="loadUniquePgsStatuses()" [disabled]="loadingPgsStatuses">
							<mat-icon>refresh</mat-icon> {{ loadingPgsStatuses ? 'Loading...' : 'Refresh from Database' }}
						</button>
					</div>

					<div *ngIf="loadingPgsStatuses" class="text-center p-3">
						<mat-spinner diameter="40"></mat-spinner>
					</div>

					<div *ngIf="!loadingPgsStatuses && uniquePgsStatuses.length === 0" class="alert alert-info">
						No PGS statuses found. Export some orders to 3PL first, then click Refresh.
					</div>

					<div *ngIf="!loadingPgsStatuses && uniquePgsStatuses.length > 0">
						<div *ngFor="let item of uniquePgsStatuses; let i = index" class="row mb-2 align-items-center">
							<div class="col-md-6">
								<div class="p-2 border rounded bg-light">
									<strong>PGS Status:</strong> "{{item.status}}"
									<span class="badge badge-secondary ml-2">{{item.count}} order(s)</span>
								</div>
							</div>
							<div class="col-md-1 text-center">
								<mat-icon>arrow_forward</mat-icon>
							</div>
							<div class="col-md-5">
								<mat-form-field appearance="fill" class="w-100">
									<mat-label>Set ERP status to</mat-label>
									<mat-select [(ngModel)]="item.mappedStatusId" [ngModelOptions]="{standalone: true}" [compareWith]="compareByStatusId">
										<mat-option [value]="">— No change</mat-option>
										<mat-option *ngFor="let s of orderStatusesForSelect" [value]="+s.order_status_id">{{ s.name }} ({{ s.order_status_id }})</mat-option>
									</mat-select>
								</mat-form-field>
							</div>
						</div>
					</div>

					<div class="row mt-3">
						<div class="col-md-6 mb-3">
							<h6 class="mb-2">Status rank order</h6>
							<mat-form-field appearance="fill" class="w-100">
								<mat-label>Rank Order (JSON Array)</mat-label>
								<textarea matInput formControlName="pgs_sync_erp_status_rank_json" rows="3" placeholder='[1, 5, 23, 29, 50]'></textarea>
								<mat-hint>Status can only move forward in this order. Leave empty for default.</mat-hint>
							</mat-form-field>
						</div>
						<div class="col-md-6 mb-3">
							<h6 class="mb-2">Protected ERP statuses</h6>
							<mat-form-field appearance="fill" class="w-100">
								<mat-label>Skip when current status is</mat-label>
								<mat-select formControlName="pgs_sync_erp_skip_when_orderstatusid" multiple placeholder="Default: [80] (Credit Hold)">
									<mat-option *ngFor="let s of orderStatusesForSelect" [value]="+s.order_status_id">{{ s.name }} ({{ s.order_status_id }})</mat-option>
								</mat-select>
								<mat-hint>Default: 80 (Credit Hold). Cancellation (90) always bypasses this.</mat-hint>
							</mat-form-field>
						</div>
					</div>
				</div>
			</mat-tab>

		</mat-tab-group>

		<!-- ── Save / Test (always visible below tabs) ──────────────────── -->
		<div class="row mt-4">
			<div class="col-md-12">
				<button mat-raised-button color="primary" (click)="saveConfig()" [disabled]="saving || configForm.invalid">
					<mat-spinner *ngIf="saving" diameter="18" class="d-inline-block mr-1"></mat-spinner>
					<span *ngIf="!saving">Save Configuration</span>
					<span *ngIf="saving">Saving...</span>
				</button>
				<button mat-raised-button color="accent" (click)="testConnection()" [disabled]="testing" class="ml-2">
					<mat-spinner *ngIf="testing" diameter="18" class="d-inline-block mr-1"></mat-spinner>
					<span *ngIf="!testing">Test Connection</span>
					<span *ngIf="testing">Testing...</span>
				</button>
			</div>
		</div>

		<div *ngIf="testResult" class="mt-3">
			<div [ngClass]="{'alert-success': testResult.success, 'alert-danger': !testResult.success}" class="alert">
				<strong>{{ testResult.success ? 'Success' : 'Failed' }}:</strong> {{ testResult.message }}
			</div>
			<div *ngIf="!testResult.success && testResult.response" class="mt-2">
				<details>
					<summary>API response</summary>
					<pre class="mb-0 p-2 bg-light small config-test-response-pre">{{ testResult.response | json }}</pre>
				</details>
			</div>
		</div>
	</form>
</div>
